import { asJsonObjectValueOrNull, type JsonObject } from "@/types/json"

const APPLY_LINKED_METRICS_TO_CONVERSATION_UPLOADS_METADATA_KEY =
  "apply_linked_metrics_to_conversation_uploads"

export function getApplyLinkedMetricsToConversationUploads(
  metadata: unknown,
): boolean {
  const metadataObject = asJsonObjectValueOrNull(metadata)
  return (
    metadataObject?.[
      APPLY_LINKED_METRICS_TO_CONVERSATION_UPLOADS_METADATA_KEY
    ] === true
  )
}

function stripUndefinedTopLevelValues(value: unknown): unknown {
  if (!value || typeof value !== "object" || Array.isArray(value)) {
    return value
  }
  const filtered: Record<string, unknown> = {}
  for (const [key, entry] of Object.entries(value as Record<string, unknown>)) {
    if (entry !== undefined) {
      filtered[key] = entry
    }
  }
  return filtered
}

export function withApplyLinkedMetricsToConversationUploadsMetadata(
  metadata: unknown,
  applyLinkedMetricsToConversationUploads: boolean | undefined,
): JsonObject {
  return {
    ...(asJsonObjectValueOrNull(stripUndefinedTopLevelValues(metadata)) ?? {}),
    [APPLY_LINKED_METRICS_TO_CONVERSATION_UPLOADS_METADATA_KEY]:
      applyLinkedMetricsToConversationUploads ?? false,
  }
}
